import { FC, useState } from 'react'
import { useForm } from 'react-hook-form'

import './style.scss'
import {
  FormLabel,
  FormLabelError,
  Select,
  Input,
  Textarea,
  Button, /* Radio, */
  FormTitle,
  FormMessageSuccess,
  FormMessageError,
  FormFieldLoading,
  Line,
  ButtonIcon,
  InputFileMultiple,
  //InputFile
} from '../../UI'
import { Modal, useModal } from '../../UI/Modal'
import { contactService } from '../../../services'
import { ContactPatientForm } from '.'
//import { ControlPreventionPage } from '../../../pages'
//import { log } from 'console'

type ContactFormProps = {
  className?: string,
  contactReasons: any[] | null,
  familyGroup: any[] | null,
  onChange(): void,
  setTabIndex: (newTabIndex: number) => void
}

interface IContactForm {
  razonContacto: number,
  patientId: string,
  message: string,
  examDate: string,
  examType: string,
  examName: string,
  sucursal: string,
  evidencia: FileList | undefined,
  /* ,
  specificRequests: string,
  petition: string */
}

const defaultValues: IContactForm = {
  razonContacto: 1,
  patientId: '',
  message: '',
  examDate: '',
  examType: '',
  examName: '',
  sucursal: '',
  evidencia: undefined,
  /* ,
  specificRequests: '',
  petition: '' */
}

const ContactForm:FC<ContactFormProps> = ({ className = '', contactReasons, familyGroup, onChange, setTabIndex  }) => {
  const { register, handleSubmit, formState: { errors }, /* watch, */ clearErrors, setError, setValue, reset } = useForm<IContactForm>({
    defaultValues
  })
  const [patient, setPatient] = useState<any | null>({})
  const [submited, setSubmited] = useState<boolean>(false)
  const [reasonContact, setReasonContact] = useState<number>(0)
  const [files, setFiles] = useState<FileList | undefined>(undefined)
  const [errorFile, setErrorFile] = useState<string>('');

  // const specificRequests = watch('specificRequests', '')
  const modal = useModal()

  const postForm = async (data: any) => {
    const resp: any = await contactService.postContact(data)

    if(resp && resp.status === 'Ok') {
      modal.setStatus('SUCCESS')
      reset(defaultValues)
      setPatient({})
      onChange()

      setTimeout(() => {
        setTabIndex(1);
      }, 3000)

    } else {
      modal.setStatus('ERROR')
    }
    setSubmited(false)
    modal.open()
  }

  const setPatientSrv = async (patientId: number) => {
    setPatient(null)
    const resp: any = await contactService.getPatientById(patientId)
    setPatient(resp.data)
  }

  const onPatientChange = (event: any) => {
    const { name, value } = event.target
    setPatientSrv(Number(value))

    if(value) clearErrors(name)
  }

  const onSubmit = (fData: IContactForm) => {
    const {
      patientId,
      message,
      examDate,
      examType,
      examName,
      sucursal,
      razonContacto
      /* ,
      specificRequests,
      petition */
    } = fData

    const d = new Date(examDate);

    // Check if the year is greater than 3000
    if (d.getFullYear() > 3000 || d.getFullYear() < 2000) {
      setError('examDate', { type: 'manual', message: 'Ingrese una fecha válida.' });
      return; // Prevent form submission
    }

    const formReg = new FormData()
    formReg.append('reason_contact_id', '' + razonContacto)
    formReg.append('patient_id', patientId)
    formReg.append('message', message)
    formReg.append('specific_requests', '0')
    formReg.append('petition', '',)
    formReg.append('examDate', (d.getDate() + 1 ).toString().padStart(2, '0') + '-' + (d.getMonth() + 1).toString().padStart(2, '0') + '-' + d.getFullYear())
    if(files !== undefined){
      for (let i = 0; i < files.length; i++) {
        formReg.append(`file_${i}`, files[i]);
      }
    }
    formReg.append('examType', examType)
    formReg.append('examName', examName)
    formReg.append('sucursal', sucursal)
  
    setSubmited(true)
    postForm(formReg)
  }

  const onReasonContact = (reason: number) => {
    setReasonContact(reason);
    setValue('razonContacto', reason); // The Rial
  }
  
  const onFileChange = (name: any, files: FileList) => {
    setFiles(files);
    setValue(name, files);
  }

  const onFileError = (type: 'ERROR' | 'CLEAR', name: any = '', value: any = '') => {
    if(value) setErrorFile(value.message);
    else if(!value) setErrorFile('');
  }

  const onDateChange = (input: any = '') => {
    const d = new Date(input.target.value);
    console.log(d.getFullYear());
    if(d.getFullYear() < 2000 || d.getFullYear() > 3000){
      setError('examDate', { type: 'manual', message: 'Ingrese una fecha válida' });
    } else {
      if(isNaN(d.getFullYear())){ 
        setError('examDate', { type: 'manual', message: 'Ingrese una fecha válida.' });
      } else {
        clearErrors('examDate');
      }
    }
  }
  
  const onDateError = (value: any = '') => {
  }

  return (
    <>

      <form noValidate autoComplete="off" className={className} onSubmit={handleSubmit(onSubmit)}>
        <FormTitle size="16">Formulario de contacto </FormTitle>
        <label htmlFor="pacienteId" className="text d-inline-block  fz-14 fw-semibold lh-4 mb-10 mt-20">Selecciona el motivo de tu contacto</label>
        <div className='d-flex flex-wrap justify-content-between'>
          <ButtonIcon className={reasonContact === 5 ? 'mb-10 btn-ico-mobile is-active' : 'mb-10 btn-ico-mobile'} size="lg" color='gray-700' iconName='user' onClick={() => onReasonContact(5)}>Mi portal INDISA</ButtonIcon>
          <ButtonIcon className={reasonContact === 6 ? 'mb-10 btn-ico-mobile is-active' : 'mb-10 btn-ico-mobile'} size="lg" color='gray-700' iconName='mis-examenes' onClick={() => onReasonContact(6)}>Visualización de<br/>exámenes</ButtonIcon>
          <ButtonIcon className={reasonContact === 2 ? 'mb-10 btn-ico-mobile is-active' : 'mb-10 btn-ico-mobile'} size="lg" color='gray-700' iconName='contact' onClick={() => onReasonContact(2)}>Reclamo</ButtonIcon>
          <ButtonIcon className={reasonContact === 1 ? 'mb-10 btn-ico-mobile is-active' : 'mb-10 btn-ico-mobile'} size="lg" color='gray-700' iconName='control-prevencion' onClick={() => onReasonContact(1)}>Sugerencia</ButtonIcon>
          <ButtonIcon className={reasonContact === 3 ? 'mb-10 btn-ico-mobile is-active' : 'mb-10 btn-ico-mobile'} size="lg" color='gray-700' iconName='users' onClick={() => onReasonContact(3)}>Felicitaciones</ButtonIcon>
          <ButtonIcon className={reasonContact === 4 ? 'mb-10 btn-ico-mobile is-active' : 'mb-10 btn-ico-mobile'} size="lg" color='gray-700' iconName='inquiries' onClick={() => onReasonContact(4)}>Otra solicitud</ButtonIcon>

          <div className='d-none'>
          <Input
                {...register('razonContacto', { required: 'Seleccione una razon de contacto' })}
                id="razonContacto"
                type="text"
                name="razonContacto"
                placeholder="Seleccione"
                fullWidth
                disabled={false}
                className="mt-10"
                version="3"
                value={reasonContact}
              />
              {errors.razonContacto && <FormLabelError>{errors.razonContacto?.message}</FormLabelError>}
          </div>
        </div>

        <div className={reasonContact !== 0 ? 'row' : 'row d-none'}>
            <fieldset className={reasonContact === 6 ? 'mt-30 lg:col-6' : 'mt-30 col-12'}>
              <FormLabel htmlFor="pacienteId" required>¿Quién es el paciente?</FormLabel>
              <div className="position-relative mt-10">
                <Select
                  {...register('patientId', { required: 'Selecciona ¿Quién es el paciente?' })}
                  id="patientId"
                  name="patientId"
                  defaultValue=""
                  className="new-select"
                  fullWidth
                  required
                  version="4"
                  error={!!errors.patientId}
                  onChange={onPatientChange}
                >
                  <option value="" disabled>Selecciona</option>
                  {familyGroup && familyGroup.length > 0 && familyGroup.map((it: any) =>
                    <option key={it.id} value={it.id}>{it.name}</option>
                  )}
                </Select>
                {familyGroup === null && <FormFieldLoading overlay />}
              </div>
              {errors.patientId && <FormLabelError>{errors.patientId?.message}</FormLabelError>}
            </fieldset>
            
            <fieldset className={reasonContact === 6 ? 'mt-30 lg:col-6' : 'd-none'}>
              <FormLabel htmlFor="examDate">Fecha examen</FormLabel>
              <Input
                {...register('examDate', { required: (reasonContact === 6 ? 'Ingrese la fecha del examen' : false) })}
                id="examDate"
                type="date"
                name="examDate"
                placeholder="Seleccione"
                fullWidth
                disabled={false}
                className="mt-10 datepicker"
                version="3"
                onChange={onDateChange}
                onError={onDateError}
              />
              {errors.examDate && <FormLabelError>{errors.examDate?.message}</FormLabelError>}
            </fieldset>

            <fieldset className={reasonContact === 6 ? 'mt-30 lg:col-6' : 'd-none'}>
              <FormLabel htmlFor="examType">Tipo Examen</FormLabel>
              <Select
                  {...register('examType', { required: (reasonContact === 6 ? 'Ingrese el tipo del examen' : false) })}
                  id="examType"
                  name="examType"
                  defaultValue=""
                  fullWidth
                  className="new-select mt-10"
                  version="4"
                  required
                  tabIndex={1}
                >
                  <option value="" disabled>Seleccionar tipo de examen</option>
                  <option value='Cardiología' selected>Cardiología</option>
                  <option value='Electroencefalografía'>Electroencefalografía</option>
                  <option value='Medicina Física'>Medicina Física</option>
                  <option value='Oftalmología'>Oftalmología</option>
                  <option value='Procedimientos Ambulatorios'>Procedimientos Ambulatorios</option>
                  <option value='Procedimientos Broncopulmonar'>Procedimientos Broncopulmonar</option>
                  <option value='Procedimientos Otorrinolaringología'>Procedimientos Otorrinolaringología</option>
                  <option value='UPC Neonatología'>UPC Neonatología</option>
                  <option value='Imagenología'>Imagenología</option>
                  <option value='Imagenología de la Mujer'>Imagenología de la Mujer</option>
                </Select>
                {errors.examType && <FormLabelError>{errors.examType?.message}</FormLabelError>}
            </fieldset>

              <fieldset className={reasonContact !== 5 && reasonContact !== 6 ?  'mt-30 lg:col-12' : 'd-none'}>
                <FormLabel htmlFor="sucursal" required>Sucursal</FormLabel>
                <Select
                    {...register('sucursal', { required: (reasonContact === 4 ? 'Seleccione su sucursal' : false) })}
                    id="sucursal"
                    name="sucursal"
                    defaultValue=""
                    fullWidth
                    className="new-select mt-10"
                    version="4"
                    required
                    tabIndex={1}
                  >
                    <option value="" selected>Seleccionar sucursal</option>
                    <option value='Maipú'>Maipú</option>
                    <option value='Providencia'>Providencia</option>
                  </Select>
                  {errors.sucursal && <FormLabelError>{errors.sucursal?.message}</FormLabelError>}
              </fieldset>

            <fieldset className={reasonContact === 6 ? 'mt-30 lg:col-6' : 'd-none'}>
              <FormLabel htmlFor="examName">Ingrese nombre del examen</FormLabel>
              <Input
                {...register('examName', { required: (reasonContact === 6 ? 'Ingrese el nombre del examen' : false) })}
                id="examName"
                type="text"
                name="examName"
                placeholder="Ingrese el nombre del examen"
                fullWidth
                version="3"
                disabled={false}
                className="mt-10"
              />
              {errors.examName && <FormLabelError>{errors.examName?.message}</FormLabelError>}
            </fieldset>     

            <fieldset className='mt-30 col-12'>
              <FormLabel htmlFor="evidencia">Adjuntar evidencia (opcional)</FormLabel>
              <InputFileMultiple
                  {...register('evidencia') }
                  id="evidencia"
                  name="evidencia"
                  butonText="Subir archivo"
                  tabIndex={4}
                  multiple={true}
                  className="budget-request-btn-file max-141"
                  onChange={onFileChange}
                  onError={onFileError}
              />
              {errorFile && <FormLabelError>{errorFile}</FormLabelError>}
            </fieldset>
            <span className='text d-block fz-12 px-20 pt-5 w-100 text-right'>Tipo de archivos permitidos: png, jpg o pdf (Máximo 20MB)</span>

            <div className="mt-30 d-none">
              <ContactPatientForm patient={patient} documentTypeName="documentTypeId2" />
              <Line className="mt-40" />
            </div>

            <fieldset className="mt-40 lg:mt-30 col-12">
              <FormLabel htmlFor="message" required>Mensaje</FormLabel>
              <Textarea
                {...register('message', { required: 'Digita Mensaje' })}
                id="message"
                name="message"
                placeholder="Escriba su mensaje aquí"
                rows={10}
                fullWidth
                tabIndex={3}
                error={!!errors.message}
                className="mt-10"
                version="3"
              />
              {errors.message && <FormLabelError>{errors.message?.message}</FormLabelError>}
            </fieldset>

            {/* <fieldset className="mt-30">
              <FormLabel required>Peticiones concretas</FormLabel>

              <div className="mt-10">
                <div className="d-inline-block">
                  <Radio
                    {...register('specificRequests', { required: 'Selecciona Peticiones concretas' })}
                    id="specificRequestsYes"
                    name="specificRequests"
                    value="true"
                    tabIndex={4}
                    error={!!errors.specificRequests}
                  />
                  <FormLabel
                    htmlFor="specificRequestsYes"
                    className="d-flex"
                  >
                    Sí
                  </FormLabel>
                </div>

                <div className="d-inline-block ml-30">
                  <Radio
                    {...register('specificRequests', { required: 'Selecciona Peticiones concretas' })}
                    id="specificRequestsNo"
                    name="specificRequests"
                    value="false"
                    tabIndex={5}
                    error={!!errors.specificRequests}
                  />
                  <FormLabel
                    htmlFor="specificRequestsNo"
                    className="d-flex"
                  >
                    No
                  </FormLabel>
                </div>
              </div>
              {errors.specificRequests && <FormLabelError>{errors.specificRequests?.message}</FormLabelError>}
            </fieldset>

            <fieldset className="mt-30">
              <FormLabel>Escriba aquí tus peticiones concretas</FormLabel>
              <Textarea
                {...register('petition')}
                id="petition"
                name="petition"
                placeholder=""
                rows={3}
                fullWidth
                tabIndex={6}
                disabled={specificRequests === 'false'}
                className="mt-10"
              />
            </fieldset> */}

          <div className="position-relative col-12 lg:col-4 lg:offset-1 mt-50 lg:mt-0 d-none">
            <ContactPatientForm patient={patient} />
          </div>

          <div className="col-12 mt-40">
            <fieldset className="contact-btn-wrapper">
              <Button
                type="submit"
                tabIndex={7}
                color="primary"
                fullWidth
                disabled={submited}
                style={{ 'height': '50px', 'borderRadius': '30px' }}
              >Solicitar contacto</Button>
            </fieldset>
            <FormTitle divider={false} className='mt-20' color='gray-700' required> Todos los campos son obligatorios</FormTitle>
          </div>
        </div>
      </form>



      <Modal show={modal.show} maxWidth="415px" onClose={() => modal.close()}>
        {modal.status === 'SUCCESS' &&
            <FormMessageSuccess
              className="py-60 px-50"
              title="¡Tu mensaje ha sido recibido con éxito!"
              message="En un plazo de 48 horas te responderemos por correo electrónico"
            />
          }
          {modal.status === 'ERROR' &&
            <FormMessageError
              className="py-60 px-50"
              message="No ha sido posible guardar contacto"
              onClick={() => modal.close()}
            />
          }
      </Modal>
    </>
  )
}

export { ContactForm }